// extracted by mini-css-extract-plugin
module.exports = {"BlogCard":"styles_BlogCard__1qEX4","FeaturedCard":"styles_FeaturedCard__wiHjP"};